import { supabase } from "../supabaseClient";

async function getAllRoles() {
  let query = supabase.from('Roles').select('*', { count: 'exact' }).order('level', {ascending: true})
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}


async function getRoleById(roleId) {
  const response = await supabase.from("Roles").select("*").eq("roleId", roleId).maybeSingle();
  return response.data;
}


async function insertUserRole(postBody) {
  return await insertQuery("Roles", postBody).select("*").maybeSingle();
}


async function updateUserRole(postBody, roleId) {
  return await updateQuery("Roles", postBody, roleId).select("*").maybeSingle();
}


async function deleteRoleById(rollId) {
  const response = await supabase.from('Roles').delete().eq('roleId', rollId);
  return response;
}



async function getRoleByParentRole(roleId) {


  const response = await supabase.from("Roles").select("*").eq("roleId", roleId).maybeSingle();

  if (response.data) {

    const level = response.data?.level;

    const responseParent = await supabase.from("Roles").select("*").lt("level", level).order('level', {ascending: false}).limit(1).maybeSingle();

    console.log("parent role : ", responseParent)

    const getUserResponse = await supabase.from("Users").select("*").eq("roleId", responseParent.data.roleId);

    console.log("user parent data : ", getUserResponse);
    return getUserResponse.data;
  }

}


async function getUserByRoleId(roleId) {
  const getUserResponse = await supabase.from("Users").select("*").eq("roleId", roleId).maybeSingle();

  return getUserResponse.data;
}

// async function getRoleParent(){
//   const response = await supabase.from("Users").select("*").eq("roleId", roleId);
//   console.log(response.data)
// }


async function getChildRoles(roleId) {
  return await supabase.from("Roles").select("*", { count: 'exact' }).eq("parentRoleId", roleId);
}

export {
  getAllRoles,
  insertUserRole,
  getRoleByParentRole,
  getRoleById,
  deleteRoleById,
  getUserByRoleId,
  updateUserRole,
  getChildRoles
};


function insertQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).insert(_postBody);
}

function updateQuery(tableName, postData, roleId) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).update(_postBody).eq('roleId', roleId);
}